import React, {useEffect, useState} from 'react'
import StrategiesSheet from './StrategiesSheet'
import Ticker from './Ticker'
import Marketplace from './Marketplace'
import Header from './Header'
import GaugeChart from './GaugeChart'
import Footer from './Footer'
import { isLargeScreen } from '../../utilities/ScreenView'
import {useParams} from "react-router-dom";
import {getMetadata} from "../../services/MetadataService";


const Main = () => {

    const [value, setValue] = useState('')
    var { name } = useParams();
    name = "strategy.tab";

    useEffect(() => {
        // const interval = setInterval(() => { listMarketplace(); listAllTickers(); setDate(new Date()); }, 10000)
        const interval = setInterval(() => { listMetadata(); }, 2000)
        return () => {  clearInterval(interval); }
    });

    function listMetadata() {
        getMetadata(name).then((response) => {
            setValue(response.data.value)
        }).catch(error => {
            console.log(error);
        })
    }

    function showStrateyTab() {
        return (
            <>
                <StrategiesSheet />
            </>
        )
    }

    return (
        <>
            <div className="container-grd">
                <div className="row">
                    <Header />
                    { value === "true" ? showStrateyTab() : "" }
                </div>
                <div className="row">
                    <Ticker />
                    { isLargeScreen() ? <Marketplace /> : '' }
                </div>
                <div className="row">
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default Main